import { type QueryClient, useQuery } from '@tanstack/react-query';
import { type QueryOptions } from 'typescript/types/QueryOptions';

import { getData as getCollection } from 'api/requests/GET_COLLECTION';

import { getQueryKey } from 'helpers/getQueryKey';

const queryKey = (id: string) => {
  return getQueryKey('COLLECTION', id);
};

const queryFn = (id: string) => {
  return () => {
    return getCollection(id);
  };
};

export type Collection = Awaited<ReturnType<typeof getCollection>>;

export const preloadCollection = (queryClient: QueryClient, id: string) => {
  return queryClient.fetchQuery({ queryFn: queryFn(id), queryKey: queryKey(id) });
};

export const useQueryCollection = (id: string, options: QueryOptions<Collection>) => {
  return useQuery({
    queryKey: queryKey(id),
    queryFn: queryFn(id),
    ...options,
  });
};
